import {Injectable} from '@angular/core';

import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AuthState} from '../auth/store/auth.state';
import {State} from '../../../reducers';

const API_URL = '/api/';

@Injectable()
export class BackendService {

	_token: any;
	_resource: string;

	constructor(protected http: HttpClient, protected authState: AuthState, protected store: Store<State>) {
		this.authState.token.subscribe((_token) => {
			this._token = _token;
		});
	}

	get token(){
	    return this._token
    }

	get apiUrl(){
	    return API_URL;
    }

	doLoad(resource = this._resource): Observable<any> {
		return this.http.get<any>( API_URL + resource, this.httpOptions)
			.pipe(catchError(this.handleError));
	}

	doDelete(resource = this._resource): Observable<any> {
		return this.http.delete<any>(API_URL + resource, this.httpOptions)
			.pipe(catchError(this.handleError));
    }

    doDeleteMultiple(record, resource = this._resource): Observable<any> {
        return this.http.post<any>(API_URL + resource, record, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

	doUpdate(record, resource = this._resource): Observable<any> {
		return this.http.post<any>(API_URL + resource + '/' + record.id, record, this.httpOptions)
			.pipe(catchError(this.handleError));
	}

	doAdd(resource: any = this._resource): Observable<any> {
		return this.http.post<any>(API_URL + resource, {}, this.httpOptions)
			.pipe(catchError(this.handleError));
	}

    doPaste(record, resource = this._resource): Observable<any> {
        return this.http.post<any>(API_URL + resource, record, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    doMove(record, resource): Observable<any> {
        return this.http.post<any>(API_URL + resource, record, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    createShare(record, resource): Observable<any> {
        return this.http.post<any>(API_URL + resource, record, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    getAllSettings(): Observable<any> {
        return this.http.get<any>( API_URL + 'settings', this.httpOptions)
           .pipe(catchError(this.handleError));
    }

    updateSettings(record): Observable<any> {
        return this.http.post<any>(API_URL + 'settings/update', record, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    getWhiteList(resource): Observable<any> {
        return this.http.get<any>( API_URL + resource, this.httpOptions)
           .pipe(catchError(this.handleError));
    }

    doSearch(resource): Observable<any> {
        return this.http.get<any>( API_URL + resource, this.httpOptions)
           .pipe(catchError(this.handleError));
    }

    doUpdateUser(record, resource = this._resource): Observable<any> {
		return this.http.post<any>(API_URL + resource, record, this.httpOptions)
			.pipe(catchError(this.handleError));
    }

    getActivities(resource): Observable<any> {
        return this.http.get<any>( API_URL + 'files/activities?' + resource, this.httpOptions)
           .pipe(catchError(this.handleError));
    }

	handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('An error occurred:', error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(
				`Backend returned code ${error.status}, ` +
				`body was: ${error.error}`);
		}
		// return an observable with a user-facing error message
		return throwError(error);
	};

	protected get httpOptions() {
		return {
			headers: new HttpHeaders({
				'Authorization': 'Bearer ' + this._token
			})
		};
	}



}
